import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

export const ClassesCoachesContainer = () => (
  <Box minH="100%" h="100%" w="100%">
    <Outlet />
  </Box>
);
